import { apiGet } from '@forwardflow/services/Axios/configs'
import { ResponseSuccess } from '@forwardflow/types'

export interface IUsageSummary {
   calls: {
      ringingOnlyCost: number
      ringingOnlyCount: number
      callTimeCost: number
      callTimeCount: number
      callTimeRingingCost: number
      callTimeTalkCost: number
   }
   sms: { cost: number; count: number }
   tokens: { cost: number; count: number }
   totalSpent: number
}

export default class BillingService {
   static async getUsageSummary(
      period: string = 'this-month',
      startDate?: string,
      endDate?: string,
   ): Promise<IUsageSummary> {
      const params = new URLSearchParams({ period })
      if (startDate) params.set('startDate', startDate)
      if (endDate) params.set('endDate', endDate)

      const data = await apiGet<ResponseSuccess<IUsageSummary>>({
         apiPath: `/credit-ledgers/usage-summary?${params.toString()}`,
      })
      return data.data
   }
}
